import { render } from "./PaymentDetailsModal.vue?vue&type=template&id=39be02ca&scoped=true"
import script from "./PaymentDetailsModal.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsModal.vue?vue&type=script&lang=js"

import "./PaymentDetailsModal.vue?vue&type=style&index=0&id=39be02ca&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39be02ca"]])

export default __exports__